export const MetamaskIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.0033 4.17578L13.5 9.02606L14.7026 6.16446L20.0033 4.17578Z" fill="black" fill-opacity="0.87" />
    <path
      d="M4.98999 4.17578L11.441 9.072L10.2972 6.16446L4.98999 4.17578ZM17.6632 15.4187L15.9312 18.0834L19.637 19.1073L20.7024 15.4778L17.6632 15.4187ZM4.30371 15.4778L5.36253 19.1073L9.06842 18.0834L7.33639 15.4187L4.30371 15.4778Z"
      fill="#E4761B"
    />
    <path
      d="M8.85934 10.9168L7.82666 12.4855L11.5064 12.6495L11.3757 8.67876L8.85934 10.9168ZM16.1338 10.9168L13.5848 8.63281L13.4999 12.6495L17.1731 12.4855L16.1338 10.9168ZM9.06849 18.084L11.2776 17.001L9.36914 15.5046L9.06849 18.084ZM13.7155 17.001L15.9312 18.084L15.624 15.5046L13.7155 17.001Z"
      fill="#E4761B"
    />
    <path
      d="M15.9311 18.0829L13.7154 17L13.8919 18.4505L13.8723 19.0609L15.9311 18.0829ZM9.06836 18.0829L11.1272 19.0609L11.1141 18.4505L11.2775 17L9.06836 18.0829Z"
      fill="#D7C1B3"
    />
    <path
      d="M11.16 14.5463L9.31689 14.0016L10.6175 13.4043L11.16 14.5463ZM13.8332 14.5463L14.3757 13.4043L15.6829 14.0016L13.8332 14.5463Z"
      fill="#233447"
    />
    <path
      d="M9.06845 18.0829L9.38218 15.4182L7.33643 15.4772L9.06845 18.0829ZM15.6175 15.4182L15.9312 18.0829L17.6632 15.4772L15.6175 15.4182ZM17.173 12.4844L13.4998 12.6485L13.8397 14.5452L14.3822 13.4032L15.6894 14.0005L17.173 12.4844ZM9.31682 14.0005L10.624 13.4032L11.16 14.5452L11.5064 12.6485L7.82662 12.4844L9.31682 14.0005Z"
      fill="#CD6116"
    />
    <path
      d="M7.82666 12.4844L9.36914 15.5035L9.31686 14.0005L7.82666 12.4844ZM15.6894 14.0005L15.624 15.5035L17.1731 12.4844L15.6894 14.0005ZM11.5064 12.6485L11.16 14.5452L11.5914 16.7833L11.6894 13.8364L11.5064 12.6485ZM13.4999 12.6485L13.3234 13.8299L13.4018 16.7833L13.8397 14.5452L13.4999 12.6485Z"
      fill="#E4751F"
    />
    <path
      d="M13.8398 14.5467L13.4019 16.7848L13.7156 17.0014L15.6241 15.5049L15.6894 14.002L13.8398 14.5467ZM9.31689 14.002L9.36918 15.5049L11.2777 17.0014L11.5914 16.7848L11.16 14.5467L9.31689 14.002Z"
      fill="#F6851B"
    />
    <path
      d="M13.8723 19.0619L13.8919 18.4515L13.7285 18.3071H11.2644L11.1141 18.4515L11.1272 19.0619L9.06836 18.084L9.78731 18.6747L11.2448 19.692H13.7481L15.2121 18.6747L15.9311 18.084L13.8723 19.0619Z"
      fill="#C0AD9E"
    />
    <path
      d="M13.7156 16.9998L13.4018 16.7832H11.5914L11.2777 16.9998L11.1143 18.4503L11.2646 18.3059H13.7286L13.892 18.4503L13.7156 16.9998Z"
      fill="#161616"
    />
    <path
      d="M20.2776 9.34109L20.8332 6.66327L20.0031 4.17578L13.7155 8.86197L16.1338 10.9163L19.5521 11.9205L20.3103 11.0344L19.9835 10.7981L20.5064 10.319L20.1011 10.004L20.624 9.60363L20.2776 9.34109ZM4.1665 6.66327L4.72206 9.34109L4.36912 9.60363L4.89199 10.004L4.4933 10.319L5.01618 10.7981L4.68938 11.0344L5.44101 11.9205L8.85931 10.9163L11.2776 8.86197L4.99003 4.17578L4.1665 6.66327Z"
      fill="#763D16"
    />
    <path
      d="M19.5521 11.9201L16.1338 10.9159L17.173 12.4845L15.624 15.5036L17.6632 15.4774H20.7024L19.5521 11.9201ZM8.85927 10.9159L5.44097 11.9201L4.30371 15.4774H7.33639L9.36907 15.5036L7.82659 12.4845L8.85927 10.9159ZM13.4998 12.6486L13.7155 8.86158L14.7089 6.16406H10.2972L11.2776 8.86158L11.5063 12.6486L11.5848 13.8431L11.5913 16.7835H13.4018L13.4148 13.8431L13.4998 12.6486Z"
      fill="#F6851B"
    />
  </svg>
);
